import { brandingMozi } from "./brandingMozi";
import { brandingMda } from "./brandingMda";
import { brandingAmi } from "./brandingAmi";
import { brandingEsghub } from "./brandingEsghub";
import { brandingCarbonlens } from "./brandingCarbonlens";
import { dark } from "./dark";
import { light } from "./light";
export var themeColors = {
  dark: dark,
  brandingMozi: brandingMozi,
  brandingMda: brandingMda,
  brandingAmi: brandingAmi,
  brandingEsghub: brandingEsghub,
  brandingCarbonlens: brandingCarbonlens,
  light: light
};